var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#008FED",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77842 9.84891L3.9145 8.19324C3.70501 8.00716 3.36661 8.00716 3.15712 8.19324C2.94763 8.37932 2.94763 8.67992 3.15712 8.866L5.40242 10.8604C5.61191 11.0465 5.95031 11.0465 6.1598 10.8604L11.8429 5.81233C12.0524 5.62624 12.0524 5.32565 11.8429 5.13956C11.6334 4.95348 11.295 4.95348 11.0855 5.13956L5.77842 9.84891Z",
    fill: "#008FED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#008FED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneTick);
export default __webpack_public_path__ + "static/media/doneTick.9a53b27e5f1c220f9251650bbe9b8723.svg";
export { ForwardRef as ReactComponent };